import React, { FC } from "react";
import cn from "classnames";

interface Props {
    width?: number;
    justify?: string;
    align?: string;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    reff?: any;
    wrap?:
        | "wrap"
        | "nowrap"
        | "-moz-initial"
        | "inherit"
        | "initial"
        | "revert"
        | "unset"
        | "wrap-reverse";
    gap?: string;
}

const Col: FC<Props> = ({
    width,
    justify,
    align,
    className,
    wrap,
    gap,
    onClick,
    reff,
    ...props
}) => {
    const style = {
        flex: width,
        justifyContent: justify || "flex-start",
        alignItems: align || "stretch",
        flexWrap: wrap || "nowrap",
        margin: gap || "0",
    };
    return (
        <div
            className={cn("col", className)}
            style={style}
            onClick={onClick}
            ref={reff}
        >
            {props.children}
        </div>
    );
};

export default Col;
